<template>
  <v-layout
    row
    justify-center
    v-if="languages"
  >
    <!-- INI MODAL -->
    <v-dialog
      v-if="data"
      v-model="dialog"
      persistent
      max-width="500"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-if="isText"
          v-model="data[languages.length === 1 ? languages[0] : locale]"
          :label="labelName.concat(showInfoEdited ? ` [${$t('common.infoEditedTranslate', locale)}]` : '')"
          :append-outer-icon="languages.length > 1 ? 'mdi-routes' : null"
          @input="(...args) => { onChange('blur', ...args) }"
          @click:append-outer="onOpenTranslate"
          :prepend-icon="dtouchDeeplTranslateActive ? 'mdi-translate' : null"
          @click:prepend="handleDeeplTranslate"
          :loading="loading"
        />
        <div
          v-else-if="isRichText"
          style="display: inline-block;width:100%;"
        >
          <table>
            <tr 
              v-if="dtouchDeeplTranslateActive && showInfoEdited"
            >
              <td colspan="2">
                {{` [${$t('common.infoEditedTranslate', locale)}]` }}
              </td>
            </tr>
            <tr>
              <td style="width:100%;">
                <vue-editor
                  v-model="data[languages.length === 1 ? languages[0] : locale]"
                  :editor-toolbar="customToolbar"
                  style="z-index: 3000"
                  @input="(...args) => { handleChangeRichTranslate(locale) }"
                />
                <!-- <ckeditor 
                  v-model="data[locale]"
                  :editor="editor" 
                  :config="options"
                /> -->
                <!-- <editor
                  v-model="data[locale]"
                  :options="options"
                  mode="wysiwyg"
                  @input="(...args) => { onChange('blur', ...args) }"
                /> -->
              </td>
              <td>
                <v-icon
                  @click="onOpenTranslate"
                >
                  {{languages.length > 1 ? 'mdi-routes' : null}}
                </v-icon>
                <v-icon
                  v-if="dtouchDeeplTranslateActive"
                  @click="handleDeeplTranslate"
                >
                  mdi-translate
                </v-icon>
              </td>
            </tr>
          </table>
          <v-progress-linear
            v-if="isRichText && loading"
            indeterminate
            color="primary"
          />
        </div>
        <v-textarea
          v-else-if="isTextArea"
          v-model="data[languages.length === 1 ? languages[0] : locale]"
          :label="labelName.concat(showInfoEdited ? ` [${$t('common.infoEditedTranslate', locale)}]` : '')"
          name="input-7-1"
          filled
          auto-grow
          :append-outer-icon="languages.length > 1 ? 'mdi-routes' : null"
          @input="(...args) => { handleCloseTranslate() }"
          @click:append-outer="onOpenTranslate"
          :prepend-icon="dtouchDeeplTranslateActive ? 'mdi-translate' : null"
          @click:prepend="handleDeeplTranslate"
          :loading="loading"
        />
        <v-layout
          v-else-if="isFile"
          wrap
        >
        <custom-file-input
          v-model="data[languages.length === 1 ? languages[0] : locale]"
          :onOpenTranslate="onOpenTranslate"
          @input="(...args) => { handleCloseTranslate() }"
        />
          <!-- <v-file-input
            v-model="fileData"
            style="margin-left: 15px"
            accept=".pdf"
            hide-input
          />1 -->
        </v-layout>
      </template>
      <v-card>
        <!-- INI TABS -->
        <v-toolbar
          :color="enterpriseColor"
          dark
          tabs
          class="toolbarTabs"
        >
          <template v-slot:extension>
            <v-tabs
              v-model="tabs"
              centered
              slider-color="white"
              :background-color="enterpriseColor"
              dark
            >
              <v-tab
                v-for="item in prepareLanguages(languages)"
                :key="item"
              >
                {{ item.toUpperCase() }}
              </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>

        <v-tabs-items v-model="tabs">
          <v-tab-item
            v-for="item in prepareLanguages(languages)"
            :key="item"
          >
            <v-card>
              <v-card-text>
                <v-text-field
                  v-if="isText"
                  v-model="data[item]"
                  :label="labelName"
                  :key="item.concat('txt')"
                  @input="(...args) => { handleCloseTranslate(item) }"
                  :loading="loading"
                />
                <vue-editor
                  v-else-if="isRichText"
                  v-model="data[item]"
                  :editor-toolbar="customToolbar"
                  @input="(...args) => { handleCloseTranslate(item) }"
                />
                <!-- <ckeditor 
                  v-else-if="isRichText"
                  :editor="editor" 
                  :config="options"
                  :key="item.concat('richText')"
                /> -->
                <!-- <editor
                  v-else-if="isRichText"
                  v-model="data[item]"
                  :options="options"
                  :key="item.concat('richText')"
                  mode="wysiwyg"
                  @input="(...args) => { onChange('blur', ...args) }"
                /> -->
                <v-textarea
                  v-else-if="isTextArea"
                  v-model="data[item]"
                  :label="labelName"
                  :key="item.concat('textArea')"
                  name="input-7-1"
                  box
                  auto-grow
                  @input="(...args) => { handleCloseTranslate(item) }"
                  :loading="loading"
                />
                <v-layout
                  v-else-if="isFile"
                  wrap
                >
                  <custom-file-input
                    v-model="data[item]"
                    :onOpenTranslate="onOpenTranslate"
                    @input="(...args) => { handleCloseTranslate() }"
                  />
                </v-layout>
                <v-progress-linear
                  v-if="isRichText && loading"
                  indeterminate
                  color="primary"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <!-- END TABS -->
        <v-card-actions>
          <v-spacer />
          <v-btn
          dark
            :color="enterpriseColor"
            @click="handleCloseDialog"
          >
            {{ $t('common.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END MODAL -->
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'
import i18n from '@/plugins/i18n'
import api from '@/services/api'
import { VueEditor, Quill } from 'vue2-editor'
import CustomFileInput from './CustomFileInput'

const fullToolbar = [
  // [{ font: ["arial"] }],
  // [{ font: [] }],
  // [{ font: [{ list: "ordered" }, { list: "bullet" }, { list: "check" }] }],
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  [{ size: ["small", false, "large", "huge"] }],
  // [{ size: ["small", false, "large", "huge"] }],
  ["bold", "italic", "underline", "strike"],
  [
    { align: "" },
    { align: "center" },
    { align: "right" },
    { align: "justify" }
  ],
  [{ header: 1 }, { header: 2 }],
  ["blockquote", "code-block"],
  [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ color: [] }, { background: [] }],
  ["link",
    // "image",
    // "formula"
  ],
  [{ direction: "rtl" }],
  ["clean"]
]
// var Font = Quill.import("formats/font");
// Font.whitelist = ["roboto"];

export default {
  name: 'Translate',
  components: {
    VueEditor,
    CustomFileInput
  },
  props: {
    label: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: Object,
      required: false,
      default: null
    },
    languages: {
      type: Array,
      required: false,
      default: null
    },
    type: {
      type: String,
      required: false,
      default: 'text'
    }
  },
  data () {
    return {
      fileData: null,
      labelName: '',
      data: undefined,
      dialog: false,
      tabs: null,
      customToolbar: fullToolbar,
      showInfoEdited: false,
      ifRichFirstLoad: true,
      loading: false,
    }
  },
  computed: {
    ...mapState('app',['totemActiveMenu', 'totemDomain', 'locale', 'dtouchDeeplTranslateActive', 'dtouchDeeplTranslateLocale']),
    workspaceID () {
      return this.$store.state.app.enterpriseID
    },
    enterpriseColor () {
      return this.$store.state.app.enterpriseColor
    },
    FontSizeContent () {
      return this.$store.state.app.FontSizeContent
    },
    locale () {
      return i18n.locale
    },
    isText () {
      return (!this.type || this.type === 'text')
    },
    isRichText () {
      return this.type === 'richText'
    },
    isTextArea () {
      return this.type === 'textArea'
    },
    isFile () {
      return this.type === 'file'
    }
  },
  watch: {
    value (v) {
      this.data = JSON.parse(JSON.stringify(v).split('#$#').join("'"))
      if (this.languages && this.languages.length > 1)
      for (let i = 0; i < this.languages.length; i++) {
        if (!this.data[this.languages[i]]) this.data[this.languages[i]] = ''
      }
    },
    label (v) {
      this.labelName = v ? `${v}` : 'common.name'
    }
  },
  mounted () {
    this.data = JSON.parse(JSON.stringify(this.value).split('#$#').join("'"))

    if (this.languages && this.languages.length > 1)
      for (let i = 0; i < this.languages.length; i++) {
        if (!this.data[this.languages[i]]) this.data[this.languages[i]] = ''
      }
    this.labelName = this.label ? `${this.label}` : 'common.name'
  },
  methods: {
    prepareLanguages (v) {
      if (this.dtouchDeeplTranslateActive && this.dtouchDeeplTranslateLocale) {
        const aux = v.filter(x => x === this.dtouchDeeplTranslateLocale)
        aux.push(...v.filter(x => x !== this.dtouchDeeplTranslateLocale))
        return aux
      } 
      return v
    },
    onOpenTranslate () {
      this.showInfoEdited = false
      this.dialog = true
    },
    onChange (action, aux) {
      if (this.dtouchDeeplTranslateActive) {
        this.showInfoEdited = true
      }
      this.$emit('input', this.data)
    },
    handleChangeRichTranslate (locale) {
      if (this.ifRichFirstLoad === false && this.dtouchDeeplTranslateActive && this.dtouchDeeplTranslateLocale === locale) {
        this.showInfoEdited = true
      }
      this.ifRichFirstLoad = false
      this.$emit('input', this.data)
    },
    handleCloseTranslate (locale) {
      if (this.dtouchDeeplTranslateActive && this.dtouchDeeplTranslateLocale === locale) {
        this.showInfoEdited = true
      }
      this.$emit('input', this.data)
    },
    async handleCloseDialog () {
      await this.handleDeeplTranslate()
      this.handleCloseTranslate ()
      this.dialog = false 
    },
    async handleDeeplTranslate () {
      if (this.dtouchDeeplTranslateActive && this.showInfoEdited) {
        this.loading = true
        const aux = await new Promise((resolve, reject) => api.put(`enterprises`, true, `${this.workspaceID}/deepl-translate`, this.data)
        .then(response => {
          resolve(response)
        }))
        if (aux && aux.data) this.data = aux.data
        this.$emit('input', this.data)
        this.loading = false
      }
      this.showInfoEdited = false
    },
  }
}
</script>
<style>
  .ql-snow .ql-tooltip {
    left: 0px !important;
  }
  .toolbarTabs .v-toolbar__content {
    height: 0px !important;
  }
  /* .ql-font span[data-value="arial"]::before {
    font-family: "Arial";
    content: "Arial" !important;
  } */
</style>
